import React from 'react';

export default function PageHeader({ title, description, actions = null }) {
  return (
    <header className="wt-page-header">
      <div className="wt-page-header__copy">
        <h1 className="wt-page-header__title">{title}</h1>
        {description ? <p className="wt-page-header__description">{description}</p> : null}
      </div>
      {actions ? <div className="wt-page-header__actions">{actions}</div> : null}
    </header>
  );
}
